import messages from './memberMessagingCatalogue.json' with { type: 'json' };

export const memberMessagingCatalogueSv: Readonly<typeof messages> = messages;
